import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface IConfirmationDialogData {
  acceptText?: string;
  cancelText?: string;
  confirmationNote: string;
  confirmationText: string;
  hideDecline?: boolean;
}

@Component({
  standalone: false,
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IConfirmationDialogData,
    private dialog: MatDialogRef<ConfirmationDialogComponent>,
  ) {}

  onDecline() {
    this.dialog.close({ confirmed: false });
  }

  onAccept() {
    this.dialog.close({ confirmed: true });
  }
}
